import { useEffect, useState } from "react";
import { listenToSectionsByCategory } from "../services/sectionService";

export function useSections(categoryId) {
  const [sections, setSections] = useState([]);
  const [sectionsLoading, setSectionsLoading] = useState(true);
  const [sectionsError, setSectionsError] = useState(null);

  useEffect(() => {
    setSectionsLoading(true);
    setSectionsError(null);

    const unsubscribe = listenToSectionsByCategory(
      categoryId,
      (data) => {
        setSections(data);
        setSectionsLoading(false);
      },
      (error) => {
        console.error("Unable to load sections:", error);
        setSectionsError(error);
        setSectionsLoading(false);
      }
    );

    return unsubscribe;
  }, [categoryId]);

  return {
    sections,
    sectionsLoading,
    sectionsError,
  };
}
